import styled from '@emotion/styled';
import Theme from 'App.theme';

export const PageContainer = styled.div`
  display: flex;
  width: 100vw;
  height: 100vh;
  overflow: hidden;
`;

export const BodyContainer = styled.div`
  flex: 1;
  overflow: hidden;
  display: flex;
  flex-direction: column;
`;

export const MainContainer = styled.main`
  display: flex;
  flex-direction: column;
  flex: 1;
  padding: ${Theme.layout.spacing.small};
  overflow-y: auto;
  overflow-x: hidden;
  background-color: ${Theme.greys.GREYF4};
  box-shadow: inset 10px 10px 50px ${Theme.greys.GREY5};
  height: 100vh;

  & .page-heading {
    display: flex;
    flex-direction: row;
    font-size: 28px;
    font-weight: 500;
    margin: 0 0 ${Theme.layout.spacing.small};

    & button {
      min-width: 32px;
      padding: 0px 8px;
    }
  }

  & .page-content {
    background-color: ${Theme.colours.white};
    padding: ${Theme.layout.spacing.small};
    border-radius: 5px;
    display: flex;
    flex-direction: column;
    flex: 1;
  }
`;
